/// <amd-module name="TFS/Admin/Common/RestClient/MarketingPreferences" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   vssf\client\webapi\httpclients\clientgeneratorconfigs\usermarketingpreferences.genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as MarketingPreferences from "../Contracts/MarketingPreferences";

export interface IMarketingPreferencesRestClient extends IVssRestClient {
    /**
     * Gets if the user is contactable.
     * 
     * @param descriptor - The subject descriptor for the user to retrieve if that user is contactable.
     */
    getContactWithOffers(descriptor: string): Promise<boolean>;
    /**
     * @param descriptor - 
     * @param value - 
     */
    setContactWithOffers(descriptor: string, value: boolean): Promise<void>;
    /**
     * @param descriptor - 
     */
    getMarketingPreferences(descriptor: string): Promise<MarketingPreferences.MarketingPreferences>;
    /**
     * @param preferences - 
     * @param descriptor - 
     */
    setMarketingPreferences(preferences: MarketingPreferences.MarketingPreferences, descriptor: string): Promise<void>;
}

class MarketingPreferencesRestClient extends RestClientBase implements IMarketingPreferencesRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Gets if the user is contactable.
     * 
     * @param descriptor - The subject descriptor for the user to retrieve if that user is contactable.
     */
    public async getContactWithOffers(
        descriptor: string
        ): Promise<boolean> {

        return this.beginRequest<boolean>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{descriptor}/ContactWithOffers",
            routeValues: {
                descriptor: descriptor
            }
        });
    }

    /**
     * @param descriptor - 
     * @param value - 
     */
    public async setContactWithOffers(
        descriptor: string,
        value: boolean
        ): Promise<void> {

        const queryValues: any = {
            value: value
        };

        return this.beginRequest<void>({
            apiVersion: "5.0-preview.1",
            method: "PUT",
            routeTemplate: "{descriptor}/ContactWithOffers",
            routeValues: {
                descriptor: descriptor
            },
            queryParams: queryValues
        });
    }

    /**
     * @param descriptor - 
     */
    public async getMarketingPreferences(
        descriptor: string
        ): Promise<MarketingPreferences.MarketingPreferences> {

        return this.beginRequest<MarketingPreferences.MarketingPreferences>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "{descriptor}/MarketingPreferences",
            routeValues: {
                descriptor: descriptor
            }
        });
    }

    /**
     * @param preferences - 
     * @param descriptor - 
     */
    public async setMarketingPreferences(
        preferences: MarketingPreferences.MarketingPreferences,
        descriptor: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "5.0-preview.1",
            method: "PUT",
            routeTemplate: "{descriptor}/MarketingPreferences",
            routeValues: {
                descriptor: descriptor
            },
            body: preferences
        });
    }

}

export const MarketingPreferencesClientName = "IMarketingPreferencesRestClient";

export function getMarketingPreferencesClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IMarketingPreferencesRestClient {
    return pageContext.getRestClient<IMarketingPreferencesRestClient>(MarketingPreferencesClientName, options);
}

RestClients.add(MarketingPreferencesClientName, { 
    factory: MarketingPreferencesRestClient,
    options: {
        serviceInstanceType: "00000038-0000-8888-8000-000000000000"
    }
});
